var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonasDesaparecidasRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "personas_desaparecidas",
    "data-name": "personas desaparecidas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8004",
    "data-name": "Rectangle 8004",
    width: 60,
    height: 60,
    fill: "#c0e4d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8002",
    "data-name": "Rectangle 8002",
    width: 59,
    height: 59,
    transform: "translate(0.562 0.178)",
    fill: "#de5e60"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8940",
    "data-name": "Group 8940",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8939",
    "data-name": "Group 8939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8938",
    "data-name": "Group 8938",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8937",
    "data-name": "Group 8937",
    opacity: 0.258,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8936",
    "data-name": "Group 8936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8935",
    "data-name": "Group 8935",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21867",
    "data-name": "Path 21867",
    d: "M30.062.178a29.5,29.5,0,1,1-29.5,29.5,29.5,29.5,0,0,1,29.5-29.5",
    fill: "#de5e60"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8989",
    "data-name": "Group 8989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21868",
    "data-name": "Path 21868",
    d: "M9.342,38.3a1.5,1.5,0,0,1-1.5-1.5,10.435,10.435,0,0,1,13.8-9.868,1.5,1.5,0,1,1-.972,2.838,7.436,7.436,0,0,0-9.833,7.03,1.5,1.5,0,0,1-1.5,1.5",
    fill: "#de5e60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21869",
    "data-name": "Path 21869",
    d: "M18.27,25.191a6.007,6.007,0,1,1,6.007-6.007,6.014,6.014,0,0,1-6.007,6.007m0-9.014a3.007,3.007,0,1,0,3.007,3.007,3.01,3.01,0,0,0-3.007-3.007",
    fill: "#de5e60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21870",
    "data-name": "Path 21870",
    d: "M50.781,38.3a1.5,1.5,0,0,1-1.5-1.5,7.436,7.436,0,0,0-9.833-7.03,1.5,1.5,0,1,1-.972-2.838,10.435,10.435,0,0,1,13.8,9.868,1.5,1.5,0,0,1-1.5,1.5",
    fill: "#de5e60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21871",
    "data-name": "Path 21871",
    d: "M41.853,25.191a6.007,6.007,0,1,1,6.007-6.007,6.014,6.014,0,0,1-6.007,6.007m0-9.014a3.007,3.007,0,1,0,3.007,3.007,3.01,3.01,0,0,0-3.007-3.007",
    fill: "#de5e60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21872",
    "data-name": "Path 21872",
    d: "M39.014,46.179a1.5,1.5,0,0,1-1.5-1.5,7.427,7.427,0,1,0-14.855,0,1.5,1.5,0,0,1-3,0,10.427,10.427,0,1,1,20.855,0,1.5,1.5,0,0,1-1.5,1.5",
    fill: "#de5e60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21873",
    "data-name": "Path 21873",
    d: "M30.086,32.452a5.908,5.908,0,1,1,5.909-5.909,5.914,5.914,0,0,1-5.909,5.909m0-8.817a2.908,2.908,0,1,0,2.909,2.908,2.911,2.911,0,0,0-2.909-2.908",
    fill: "#de5e60"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonasDesaparecidasRed);
export default __webpack_public_path__ + "static/media/personas_desaparecidas_red.1c8185630a8aa9ed96461d4a5c7346d4.svg";
export { ForwardRef as ReactComponent };